// extracted by mini-css-extract-plugin
module.exports = {"OrderItemWrapper":"styles_OrderItemWrapper__106Zk"};